/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/v3/promo/backlink": {
    get: operations["GetApiV3PromoBacklink"];
    post: operations["PostApiV3PromoBacklink"];
  };
  "/api/v3/promo/banners": {
    get: operations["GetApiV3PromoBanners"];
  };
  "/api/v3/promo/banners/landings": {
    get: operations["GetApiV3PromoBannersLandings"];
  };
  "/api/v3/promo/banners/sizes": {
    get: operations["GetApiV3PromoBannersSizes"];
  };
  "/api/v3/promo/banners/{id}": {
    get: operations["GetApiV3PromoBannersId"];
  };
  "/api/v3/promo/banners/{id}/download": {
    get: operations["GetApiV3PromoBannersIdDownload"];
  };
  "/api/v3/promo/banners/{id}/landings": {
    get: operations["GetApiV3PromoBannersIdLandings"];
  };
  "/api/v3/promo/landings": {
    get: operations["GetApiV3PromoLandings"];
  };
  "/api/v3/promo/landings/{id}": {
    get: operations["GetApiV3PromoLandingsId"];
  };
  "/api/v3/promo/locales": {
    get: operations["GetApiV3PromoLocales"];
  };
  "/api/v3/promo/platforms": {
    get: operations["GetApiV3PromoPlatforms"];
  };
  "/api/v3/promo/videos": {
    get: operations["GetApiV3PromoVideos"];
  };
  "/healthcheck": {
    get: operations["GetHealthcheck"];
  };
}

export interface components {
  schemas: {
    Backlink: {
      url: string;
    };
    Banner: {
      /**
       * Format: int
       * @example 1234
       */
      advertiserId: number;
      /**
       * Format: int64
       * @example 1234
       */
      id: number;
      /** @example https://images01.iqoption.com/33/2833/static-00656493823584632833.jpg */
      image: string;
      /** @example false */
      isUniversal: boolean;
      links: { [key: string]: components["schemas"]["BannerLink"] };
      locales: string[];
      /** @example Grid banners */
      name: string;
      /** @example 151 */
      rating: number;
      sizes: string[];
    };
    BannerLink: {
      /**
       * Format: int64
       * @example 1234
       */
      bannerId: number;
      files: { [key: string]: components["schemas"]["BannerLinkFile"] };
      /** @example https://static.cdnpub.info/files/storage/public/5e/5c/d5e7c9e485h9c0g2e9.jpg */
      link: string;
      /**
       * Format: int64
       * @example 66183
       */
      linkId: number;
      /** @example en_US */
      locale: string;
      /** @example 200x200 */
      size: string;
      type: components["schemas"]["FileFormat"];
    };
    BannerLinkFile: {
      [key: string]: components["schemas"]["BannerLinkFileInfo"];
    };
    BannerLinkFileInfo: {
      name?: string;
      server: string;
      uri: string;
    };
    BannerSizes: {
      /**
       * @example [
       *   "100x200",
       *   "400x500",
       *   "50x200"
       * ]
       */
      size?: string[];
    };
    BannersCollection: components["schemas"]["Collection"] & {
      data: components["schemas"]["Banner"][];
    };
    BannersLandings: {
      landings: {
        id: number;
        titles: { [key: string]: string };
      }[];
    };
    Collection: {
      totalCount: number;
    };
    Error: {
      error?: components["schemas"]["ErrorItem"];
    };
    ErrorField: {
      /** @description translation key of error */
      key?: string;
      params?: { [key: string]: string };
    };
    /**
     * @example {
     *   "common": {
     *     "key": "api_error.rate_limit",
     *     "params": {
     *       "until": 1551908007642
     *     }
     *   },
     *   "fields": {
     *     "name": {
     *       "key": "api_error.validation_is_int",
     *       "params": {
     *         "value": "whatever was passed as non int"
     *       }
     *     }
     *   }
     * }
     */
    ErrorItem: {
      _global?: components["schemas"]["ErrorField"];
      fields?: { [key: string]: components["schemas"]["ErrorField"] };
    };
    /** @enum {string|null} */
    FileFormat: ("image" | "html5" | "gif") | null;
    HealthcheckResponse: {
      alive: boolean;
    };
    Landing: {
      advertiserId: number;
      /** @description Language - description pairs */
      descriptions: { [key: string]: string };
      id: number;
      links: { [key: string]: components["schemas"]["LandingLink"] };
      name: string;
      platformType: number;
      rating: number;
      /** @description Language - description pairs */
      titles: { [key: string]: string };
    };
    LandingLink: {
      description: string;
      image: string;
      /** Format: int */
      landingId: number;
      link: string;
      /** Format: int */
      linkId: number;
      locale: string;
      title: string;
    };
    LandingsCollection: components["schemas"]["Collection"] & {
      data: components["schemas"]["Landing"][];
    };
    LandingsLocales: { [key: string]: string };
    /** @description 1 - Web, 2 - Mobile */
    LandingsPlatforms: (1 | 2)[];
    Video: {
      advertiserId: number;
      created?: string;
      descriptions: { [key: string]: string };
      duration: number;
      id: number;
      links: components["schemas"]["VideoLink"][];
      rating: number;
      titles: { [key: string]: string };
      updated?: string;
    };
    VideoCollection: components["schemas"]["Collection"] & {
      data: components["schemas"]["Video"][];
    };
    VideoLink: {
      description: string;
      /** @deprecated */
      hosting: number;
      link: string;
      linkId: number;
      locale: string;
      /** @deprecated */
      params: string;
      title: string;
      videoId: number;
    };
  };
  parameters: {
    Advertisers: number[];
    DurationVideo: "short" | "long";
    FileFormats: components["schemas"]["FileFormat"][];
    /** @description The id of the entity */
    Id32: number;
    /**
     * @example [
     *   "1200x628"
     * ]
     */
    ImageSizes: string[];
    LandingIDs: number[];
    Locale: string;
    Locales: string[];
    PageSizeParam: number;
    PageSkipParam: number;
    Platforms: number[];
  };
  requestBodies: {
    BacklinkPost: {
      content: {
        "application/json": {
          url?: string;
        };
      };
    };
  };
}

export interface operations {
  GetApiV3PromoBacklink: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["Backlink"];
        };
      };
      /** Not found backlink */
      404: unknown;
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  PostApiV3PromoBacklink: {
    responses: {
      /** Success */
      201: {
        content: {
          "application/json": components["schemas"]["Backlink"];
        };
      };
      /** Bad request */
      400: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
    requestBody: components["requestBodies"]["BacklinkPost"];
  };
  GetApiV3PromoBanners: {
    parameters: {
      query: {
        skip?: components["parameters"]["PageSkipParam"];
        first?: components["parameters"]["PageSizeParam"];
        locales?: components["parameters"]["Locales"];
        imageSizes?: components["parameters"]["ImageSizes"];
        fileFormats?: components["parameters"]["FileFormats"];
        advertisers?: components["parameters"]["Advertisers"];
        landingIds?: components["parameters"]["LandingIDs"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["BannersCollection"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoBannersLandings: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["BannersLandings"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoBannersSizes: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["BannerSizes"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoBannersId: {
    parameters: {
      path: {
        /** The id of the entity */
        id: components["parameters"]["Id32"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["Banner"];
        };
      };
      /** Not found banner */
      404: unknown;
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoBannersIdDownload: {
    parameters: {
      path: {
        /** The id of the entity */
        id: components["parameters"]["Id32"];
      };
      query: {
        locale?: components["parameters"]["Locale"];
        imageSizes?: components["parameters"]["ImageSizes"];
        fileFormats?: components["parameters"]["FileFormats"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/zip": string;
        };
      };
      /** Not found banner */
      404: unknown;
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoBannersIdLandings: {
    parameters: {
      path: {
        /** The id of the entity */
        id: components["parameters"]["Id32"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["LandingsCollection"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoLandings: {
    parameters: {
      query: {
        advertisers?: components["parameters"]["Advertisers"];
        locales?: components["parameters"]["Locales"];
        platforms?: components["parameters"]["Platforms"];
        skip?: components["parameters"]["PageSkipParam"];
        first?: components["parameters"]["PageSizeParam"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["LandingsCollection"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoLandingsId: {
    parameters: {
      path: {
        /** The id of the entity */
        id: components["parameters"]["Id32"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["Landing"];
        };
      };
      /** Not found user */
      404: unknown;
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoLocales: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["LandingsLocales"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoPlatforms: {
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["LandingsPlatforms"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetApiV3PromoVideos: {
    parameters: {
      query: {
        skip?: components["parameters"]["PageSkipParam"];
        first?: components["parameters"]["PageSizeParam"];
        locales?: components["parameters"]["Locales"];
        advertisers?: components["parameters"]["Advertisers"];
        duration?: components["parameters"]["DurationVideo"];
      };
    };
    responses: {
      /** Success */
      200: {
        content: {
          "application/json": components["schemas"]["VideoCollection"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
  GetHealthcheck: {
    responses: {
      /** Successful operation with token in cookie */
      200: {
        content: {
          "application/json": components["schemas"]["HealthcheckResponse"];
        };
      };
      /** Unexpected Error */
      default: {
        content: {
          "application/json": components["schemas"]["Error"];
        };
      };
    };
  };
}

export interface external {}

export enum ApiPaths {
  GetApiV3PromoBacklink = "/api/v3/promo/backlink",
  PostApiV3PromoBacklink = "/api/v3/promo/backlink",
  GetApiV3PromoBanners = "/api/v3/promo/banners",
  GetApiV3PromoBannersLandings = "/api/v3/promo/banners/landings",
  GetApiV3PromoBannersSizes = "/api/v3/promo/banners/sizes",
  GetApiV3PromoBannersId = "/api/v3/promo/banners/:id",
  GetApiV3PromoBannersIdDownload = "/api/v3/promo/banners/:id/download",
  GetApiV3PromoBannersIdLandings = "/api/v3/promo/banners/:id/landings",
  GetApiV3PromoLandings = "/api/v3/promo/landings",
  GetApiV3PromoLandingsId = "/api/v3/promo/landings/:id",
  GetApiV3PromoLocales = "/api/v3/promo/locales",
  GetApiV3PromoPlatforms = "/api/v3/promo/platforms",
  GetApiV3PromoVideos = "/api/v3/promo/videos",
  GetHealthcheck = "/healthcheck",
}
